import { defineComponent } from "vue";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";
import SoundFX from "@/assets/shared/sounds/fim.mp3";
import { mapWritableState } from "pinia";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import blankVideo from "@/assets/shared/blank.webm";
import ThemesHelper from "@/helpers/ThemesHelper";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

export default defineComponent({
  components: {
    BaseModal,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["patient"]),
  },
  data() {
    return {
      counter: 0,
      audio: new Audio(SoundFX),
      blankVideoPath: blankVideo,
      StepContent: ThemesHelper.getThemeParams("testStepThreeContents"),
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
      this.stopCounter();
    },
    goBack(){
      clearInterval(this.counter);
      this.toggleModal(false);
    },
    goAhead(){
      GoogleAnalyticsEvents.callJumpCounter();
      clearInterval(this.counter);
      this.$emit("nextStep");
      this.toggleModal(false);
    },
    setCircleCounter($percent: number) {
      const circle: any = this.$refs["circleCounter"];
      circle.style.strokeDashoffset = $percent * 477.52 * -1;
    },
    setCounterText($valor: any) {
      const texto: any = this.$refs["textCounter"];
      texto.textContent = $valor;
    },
    initializeSound() {
      this.audio.play();
      this.audio.pause();
    },
    playSound() {
      this.audio.play();
    },
    countdownTimeStart(min: number) {
      const countDownDate = new Date().getTime();
      const totalMiliseconds = min * 60 * 1000;
      this.counter = setInterval(() => {
        const now = new Date().getTime();
        const percentCompleted =
          ((countDownDate - now) / totalMiliseconds) * -1;
        const distance = countDownDate + totalMiliseconds - now;
        const minutes: string = (
          "0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        ).slice(-2);
        const seconds: string = (
          "0" + Math.floor((distance % (1000 * 60)) / 1000)
        ).slice(-2);

        this.setCounterText(minutes + ":" + seconds);
        this.setCircleCounter(percentCompleted);

        if (distance < 0) {
          this.stopCounter();
          this.setCounterText("00:00");
          this.playSound();
          this.goAhead();
        }
      }, 10);
    },
    stopCounter() {
      clearInterval(this.counter);
    },
  },
});
